<div *ngIf="reviewOK; else notReviewer">
  <h2>Dashboard</h2>
  <responses></responses>
</div>
<ng-template #notReviewer>You are not an authorised reviewer</ng-template>
